import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CalendarIcon } from "assets/svgs/calendar.svg";
import { shortDate } from "helpers/format-date";
import navigate from "helpers/navigate";
import { TOGGLE_SCHEDULED_ORDERS_MODAL } from "utils/action-types";
import obtainOrderInfo from "utils/obtain-order-info";

const NextDeliveryDate = ({ className = "", callback }) => {
	const { nextBillingDate, chargeOffsetDays } = useSelector((state) => state.account.subscription);
	const { authenticated, latestSubOrder } = useSelector((state) => state.account.profile);
	const { date } = obtainOrderInfo(nextBillingDate, chargeOffsetDays, latestSubOrder);

	const dispatch = useDispatch();

	if (!authenticated) return null;

	const handleClick = () => {
		if (!nextBillingDate) return navigate("/account/subscription");

		dispatch({ type: TOGGLE_SCHEDULED_ORDERS_MODAL });
		callback && callback();
	};

	return (
		<button onClick={handleClick} className={`header-icon ${className} py-1.5`}>
			<CalendarIcon />
			<div className="lg:flex">
				{nextBillingDate && shortDate(date)}
			</div>
		</button>
	);
};

export default NextDeliveryDate;